import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";

export class TombOfNefertitiMainGameIdleAnimationView extends BaseView {
    private _layer:PIXI.Container;
    private _dust:TimelineSprite;

    public playAnimation():void {
        this._dust.getAnimationAutoShowHide(true, true);
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.IDLE.name);

        const dust = new TimelineSprite(GameResources.getTextures("dust"));

        dust.blendMode = PIXI.BLEND_MODES.ADD;
        dust.anchor.set(0.5);
        dust.scale.set(4);
        dust.width = 1680; // #323 fix
        dust.position.set(TombOfNefertitiGameConfig.instance.GAME_WIDTH / 2, 0);
        dust.visible = false;
        dust.alpha = 0.5;

        this._layer.addChild(dust);

        this._dust = dust;
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._dust.y = 930;
        } else {
            this._dust.y = 480;
        }
    }
}